import { router } from '../util/router'

/**
 * Close accordion
 */
function closeAccordion($accordion) {
  $accordion
    .find('.accordion__content')
    .slideUp(function () {
      $accordion.removeClass('open')
      $accordion.addClass('closed')
    })
}

/**
 * Open accordion
 */
function openAccordion($accordion) {
  $accordion
    .find('.accordion__content')
    .slideDown(function () {
      $accordion.removeClass('closed')
      $accordion.addClass('open')
    })
}

router.on('common', 'init', () => {
  $('.accordion__toggle').on('click', function () {
    let $accordion = $(this).closest('.accordion')

    if ($accordion.hasClass('open')) {
      closeAccordion($accordion)
    } else {
      openAccordion($accordion)
    }
  })

})



// WEBPACK FOOTER //
// ./scripts/components/accordion.js